module.exports = __webpack_public_path__ + "media/img/scholarships/search-by-algolia-light-background-155bab7739d69c84c269d15f9c9a9113.svg";